export default __webpack_public_path__ + "static/media/tiktok.86a847bd.svg";